/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_TitleInputs */

const en_company_jobs_title = /** @type {(inputs: Company_Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Job Postings`)
};

const de_company_jobs_title = /** @type {(inputs: Company_Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Stellenangebote`)
};

/**
* | output |
* | --- |
* | "My Job Postings" |
*
* @param {Company_Jobs_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_title = /** @type {((inputs?: Company_Jobs_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_title(inputs)
	return en_company_jobs_title(inputs)
});